// extracted by extract-css-chunks-webpack-plugin
module.exports = {"categoryGrid":"BvlTW7","card":"S1a6RV","mediumGrid":"_2KIzXI","smallGrid":"_31cAro","noMargin":"_3aQhbb"};